import { jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import ClientSideComponent from "../../../ClientSideComponent.js";
const LazyRightSectionWrapper = /*#__PURE__*/ lazy(()=>import("./RightSectionWrapper.js"));
const RightSectionWrapper = ()=>/*#__PURE__*/ jsx(ClientSideComponent, {
        children: /*#__PURE__*/ jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ jsx(LazyRightSectionWrapper, {})
        })
    });
const RightSectionWrapper_LazyRightSectionWrapper = RightSectionWrapper;
export default RightSectionWrapper_LazyRightSectionWrapper;
